import { CSSProperties } from 'react';

import PbmPromotionsLayout from '@/resources/components/product/pbmPromotions';
import { useModalReturn } from '@/resources/hooks/useModal';
import { ICartProduct } from '@/store/ducks/order/types';
import { IOptionGroup, IProduct } from '@/store/ducks/products/types';

import BuyForm from '../BuyForm';
import { ProductWithPbmPromotions } from './ProductWithPbmPromotions';

interface FormContentRendererProps {
  action: 'add' | 'receive';
  product: IProduct | ICartProduct;
  pbmPromotions: any[] | undefined;
  showType?: 'Default' | 'Product' | 'Carousel' | 'OneLine';
  pbmBuyButton: boolean;
  configs: any;
  styles?: CSSProperties;
  btnStyles?: CSSProperties;
  fullWidth: boolean;
  formClasses: string;
  optionModal: useModalReturn;
  optionsGroup: IOptionGroup | null;
  currentMeasure: 'kg' | 'unity';
  quantityInputDirection?: 'center' | 'end';
  isAvailable?: boolean;
  hideQuantityInput: boolean;
}

export const FormContentRenderer = ({
  action,
  product,
  pbmPromotions,
  showType,
  pbmBuyButton,
  configs,
  styles,
  btnStyles,
  fullWidth,
  formClasses,
  optionModal,
  optionsGroup,
  currentMeasure,
  quantityInputDirection,
  isAvailable,
  hideQuantityInput,
}: FormContentRendererProps) => {
  const hasPbmPromotions = pbmPromotions && pbmPromotions.length > 0;
  const shouldShowPbm = hasPbmPromotions && configs.show_pbm_price;

  const buyFormProps = {
    action,
    product,
    styles,
    btnStyles,
    fullWidth,
    formClasses,
    optionModal,
    optionsGroup,
    currentMeasure,
    quantityInputDirection,
    isAvailable,
    hideQuantityInput,
  };

  if (!shouldShowPbm) {
    return <BuyForm {...buyFormProps} pbmBuyButton={pbmBuyButton} />;
  }

  if (showType === 'Product') {
    return (
      <ProductWithPbmPromotions
        {...buyFormProps}
        showType={showType}
        pbmPromotions={pbmPromotions}
        pbmBuyButton={pbmBuyButton}
      />
    );
  }

  if (showType === 'OneLine' && pbmBuyButton) {
    return <BuyForm {...buyFormProps} pbmBuyButton={pbmBuyButton} />;
  }

  if (showType && configs.show_pbm_price) {
    return <PbmPromotionsLayout pbmPromotions={pbmPromotions} type={showType} product={product} />;
  }

  return <BuyForm {...buyFormProps} />;
};
